import { ComponentType } from 'react'
import { Col, Container, Row } from 'reactstrap'
import styled from 'styled-components'
import { AgentCard } from 'views/agents/agent-card'

const Wrapper = styled.div`
  padding: 44px 0;
`

const Title = styled.h5`
  padding-left: 16px;
  margin-bottom: calc(32px - 22px);
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
`

const SliderWrapper = styled.div`
  padding: 22px 0;
`

const Slider = styled.div`
  border-radius: 10px;
  background: #f7f8f9;
  height: 0;
  padding-bottom: 110%;
`

const AgentCardWrapper = styled.div`
  padding: 22px 0;
`

interface Props {
  agents: any[]
}

export const AdminsDesktop: ComponentType<Props> = ({ agents }) => (
  <Wrapper>
    <Container>
      <Row>
        <Col>
          <Title>Equipo de Administración</Title>
        </Col>
      </Row>
      <div className="five-big-row">
        {agents.map(agent => (
          <div key={agent.uuid} className="five-big-col-1">
            <AgentCardWrapper>
              <AgentCard agent={agent} />
            </AgentCardWrapper>
          </div>
        ))}
      </div>
      {/* <div className="five-big-row">
        <div className="five-big-col-3 pb-55">
          <SliderWrapper>
            <Slider />
          </SliderWrapper>
        </div>
      </div> */}
    </Container>
  </Wrapper>
)
